import './css/main.css'
import { Link, useNavigate } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faCalendar, faSquareXmark } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useRef, useState } from 'react';
import NewPage from './common/NewPage'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { checkLogin } from '../store';
import { SyncLoader } from "react-spinners";
import Message from './common/message';

function TouchImg() {
    const dark = useSelector((state) => state.Darkmode.value);
    const darkname = dark ? "dark" : "";

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [circleData, setCircleData] = useState([]);
    const [backgroundData, setBackgroundData] = useState([]);

    const [circleImage, setCircleImage] = useState(null); // 원판 이미지 상태
    const [backgroundImage, setBackgroundImage] = useState(null); // 배경 이미지 상태

    const [originalCircleImage, setOriginalCircleImage] = useState(null); // 원래 원판 이미지
    const [originalBackgroundImage, setOriginalBackgroundImage] = useState(null); // 원래 배경 이미지

    const [circleFile, setCircleFile] = useState(null); // 원판 이미지 파일
    const [backgroundFile, setBackgroundFile] = useState(null); // 배경 이미지 파일

    const [reload, setReload] = useState(false);

    useEffect(() => {
        CircleData();
        BackgroundData();
    }, [reload]);

    const CircleData = async () => {
        await axios
            .get(process.env.REACT_APP_API + "/api/circle")
            .then((response) => {
                const tmp = response.data;
                console.log(tmp)
                if (tmp?.code === 1000) {
                    const circleUrl = tmp?.data?.circle[0]?.circle_url ?? "";
                    setCircleData(tmp?.data?.circle[0] ?? []);
                    setCircleImage(circleUrl);
                    setOriginalCircleImage(circleUrl);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const BackgroundData = async () => {
        await axios
            .get(process.env.REACT_APP_API + "/api/bg")
            .then((response) => {
                const tmp = response.data;
                console.log(tmp)
                if (tmp?.code === 1000) {
                    const bgUrl = tmp?.data?.background[0]?.bg_url ?? "";
                    setBackgroundData(tmp?.data?.background[0] ?? []);
                    setBackgroundImage(bgUrl);
                    setOriginalBackgroundImage(bgUrl);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const handleFileChange = (file, setImage, setFile) => {
        if (file) {
            const reader = new FileReader();
            reader.onload = () => {
                setImage(reader.result); // 미리보기 이미지 URL 설정
            };
            reader.readAsDataURL(file);
            setFile(file); // 실제 파일 객체 저장
        }
    };

    const handleCancel = (setImage, setFile, originalImage) => {
        setImage(originalImage); // 원래 이미지로 복원
        setFile(null); // 파일 초기화
    };

    const handleSave = async (file, id, type) => {
        if (!file) {
            alert("이미지를 선택하세요.");
            return;
        }

        const formData = new FormData();
        formData.append(type === "circle" ? "circleId" : "bgId", id ?? "");
        formData.append("status", "1");
        formData.append("file", file);

        await axios
            .post(
                process.env.REACT_APP_API + (type === "circle" ? "/api/circle/update" : "/api/bg/update"),
                formData,
                {
                    headers: { "Content-Type": "multipart/form-data" },
                }
            )
            .then((response) => {
                const tmp = response?.data;
                console.log(tmp)
                if (tmp?.code < 2000) {
                    setReload((e) => !e); // 데이터 갱신
                } else {
                    alert("업로드 실패");
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };

    const handleBackgroundAdd = async (file) => {
        if (!file) {
            alert("이미지를 선택하세요.");
            return;
        }

        const formData = new FormData();
        formData.append("file", file);

        await axios
            .post(
                process.env.REACT_APP_API + "/api/bg",
                formData,
                {
                    headers: { "Content-Type": "multipart/form-data" },
                }
            )
            .then((response) => {
                const tmp = response?.data;
                console.log(tmp)
                if (tmp?.code < 2000) {
                    setReload((e) => !e); // 데이터 갱신
                } else {
                    alert("업로드 실패");
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };

    const handleBackgroundDelete = async (id) => {
        if (!window.confirm("정말로 삭제하시겠습니까?")) return;

        await axios
            .post(process.env.REACT_APP_API + "/api/bg/delete", { bgId: id })
            .then((response) => {
                const tmp = response?.data;
                if (tmp?.code < 2000) {
                    setReload((e) => !e); // 데이터 갱신
                } else {
                    alert("삭제 실패");
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };

    const UploadArea = ({
        image,
        setImage,
        label,
        originalImage,
        file,
        setFile,
        type,
        id
    }) => {
        const [isDragging, setIsDragging] = useState(false); // 개별 드래그 상태 관리

        const handleDrop = (e) => {
            e.preventDefault();
            const file = e.dataTransfer.files[0];
            handleFileChange(file, setImage, setFile);
            setIsDragging(false); // 드래그 상태 해제
        };

        const isModified = image !== originalImage && file !== null; // 기존 이미지와 다를 때 수정 상태
        const hasImage = !!originalImage; // 기존 이미지 여부 확인

        return (
            <div>
                <div
                    className={`upload-area ${darkname}`}
                    style={{
                        width: "350px",
                        height: "700px",
                        border: isDragging ? "2px solid #2196F3" : "2px dashed #ccc",
                        borderRadius: "10px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        position: "relative",
                        backgroundColor: isDragging
                            ? "rgba(33, 150, 243, 0.1)"
                            : image
                                ? "#f8f8f8"
                                : "transparent",
                        overflow: "hidden",
                        transition: "all 0.3s ease",
                    }}
                    onDragOver={(e) => {
                        e.preventDefault();
                        setIsDragging(true); // 드래그 상태 활성화
                    }}
                    onDragEnter={(e) => {
                        e.preventDefault();
                        setIsDragging(true); // 드래그 상태 활성화
                    }}
                    onDragLeave={(e) => {
                        e.preventDefault();
                        setIsDragging(false); // 드래그 상태 비활성화
                    }}
                    onDrop={handleDrop} // 드롭 이벤트 처리
                >
                    {image ? (
                        <img
                            src={image}
                            alt={`${label} 미리보기`}
                            style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "contain",
                            }}
                        />
                    ) : (
                        <div
                            style={{
                                color: isDragging ? "#2196F3" : "#888",
                                textAlign: "center",
                            }}
                        >
                            {isDragging
                                ? "드롭하세요!"
                                : "이미지를 드래그하거나 클릭하여 업로드하세요"}
                        </div>
                    )}
                    <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => handleFileChange(e.target.files[0], setImage, setFile)}
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            opacity: 0,
                            cursor: "pointer",
                        }}
                    />
                </div>
                <div className="modal-btn-box" style={{ marginTop: "20px" }}>
                    {!hasImage && file && type === "background" && (
                        <div
                            className={`modal-btn ${darkname}`}
                            onClick={() => handleBackgroundAdd(file)} // 등록 버튼
                        >
                            등록
                        </div>
                    )}
                    {hasImage && !isModified && type === "background" && (
                        <div
                            className={`modal-btn ${darkname}`}
                            onClick={() => handleBackgroundDelete(id)} // 삭제 버튼
                        >
                            삭제
                        </div>
                    )}
                    {hasImage && isModified && (
                        <>
                            <div
                                className={`modal-btn ${darkname}`}
                                onClick={() => handleSave(file, id, type)} // 수정 버튼
                            >
                                수정
                            </div>
                            <div
                                className={`modal-btn ${darkname}`}
                                onClick={() => handleCancel(setImage, setFile, originalImage)} // 취소 버튼
                            >
                                취소
                            </div>
                        </>
                    )}
                </div>
            </div>
        );
    };

    return (
        <div className="main">
            <div className={`main-box ${darkname}`} style={{ display: "flex", gap: "50px" }}>
                {/* 원판 이미지 업로드 */}
                <div>
                    <div className="maintab">
                        <div className={`maintab-btn on ${darkname}`}>원판이미지</div>
                    </div>
                    <UploadArea
                        image={circleImage}
                        setImage={setCircleImage}
                        label="원판 이미지"
                        originalImage={originalCircleImage}
                        file={circleFile}
                        setFile={setCircleFile}
                        type="circle"
                        id={circleData.id}
                    />
                </div>

                {/* 배경 이미지 업로드 */}
                <div>
                    <div className="maintab">
                        <div className={`maintab-btn on ${darkname}`}>배경이미지</div>
                    </div>
                    <UploadArea
                        image={backgroundImage}
                        setImage={setBackgroundImage}
                        label="배경 이미지"
                        originalImage={originalBackgroundImage}
                        file={backgroundFile}
                        setFile={setBackgroundFile}
                        type="background"
                        id={backgroundData.id}
                    />
                </div>
            </div>
        </div>
    );
}

export default TouchImg;